import { render, staticRenderFns } from "./GradientBarComponent.vue?vue&type=template&id=3c8f1e80&scoped=true&"
import script from "./GradientBarComponent.vue?vue&type=script&lang=js&"
export * from "./GradientBarComponent.vue?vue&type=script&lang=js&"
import style0 from "./GradientBarComponent.vue?vue&type=style&index=0&id=3c8f1e80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8f1e80",
  null
  
)

export default component.exports